export const getLastUsedElementIndex = (element, elementalsTokens) => {
  return elementalsTokens.findLastIndex(token => token.tokenName === element && token.isUsed === true);
}
